import { render, staticRenderFns } from "./CrudStoreAttributes.vue?vue&type=template&id=c062c1b0&scoped=true"
import script from "./CrudStoreAttributes.vue?vue&type=script&lang=js"
export * from "./CrudStoreAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c062c1b0",
  null
  
)

export default component.exports